module.exports = __webpack_public_path__ + "static/media/katheryn-winnick.f5bd0337.jpg";